export function initOrderHistory() {
    document.addEventListener("DOMContentLoaded", () => {
        const accordions = document.querySelectorAll(".tmp-orderhistory [data-accordion]");
        if (!accordions.length) {
            return;
        }

        accordions.forEach(acc => {
        const toggle = acc.querySelector("[data-accordion-toggle]");
        const content = acc.querySelector("[data-accordion-content]");
        const icon = toggle?.querySelector(".order-accordion__icon");

        if (!toggle || !content) {
            return;
        }

        const plusSrc = icon?.dataset.iconPlus || icon?.getAttribute("src");
        const minusSrc = icon?.dataset.iconMinus || plusSrc;

        const setState = (open) => {
            acc.classList.toggle("open", open);
            toggle.setAttribute("aria-expanded", open.toString());
            content.hidden = !open;

            if (icon && plusSrc && minusSrc) {
                icon.setAttribute("src", open ? minusSrc : plusSrc);
                icon.setAttribute("alt", open ? "Collapse order" : "Expand order");
            }
        };

        setState(acc.classList.contains("open"));

        toggle.addEventListener("click", () => {
            setState(!acc.classList.contains("open"));
        });
        });
    });
}
